import moment from "moment";
import React from "react";

export default function NotificationItem(props) {
  const { notification } = props;
  const { notificationIcon, name, action, date } = notification;
  const formattedDate = moment(date).fromNow();

  
  return (
    <button
      className="block text-left cursor-pointer hover:bg-gray-100 w-full text-gray-900 dark:text-gray-300 mb-2 py-2 px-4"
      role="alert"
    >
      <div className="flex justify-between items-center">
        <div className="relative inline-block shrink-0">
          <img
            className="block w-12 h-12 rounded-full"
            src={notificationIcon}
            alt="Jese Leos"
          />
          <span className="absolute bottom-0 right-0 inline-flex items-center justify-center w-6 h-6 bg-blue-600 rounded-full">
            <svg
              aria-hidden="true"
              className="w-4 h-4 text-white"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M18 13V5a2 2 0 00-2-2H4a2 2 0 00-2 2v8a2 2 0 002 2h3l3 3 3-3h3a2 2 0 002-2zM5 7a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1zm1 3a1 1 0 100 2h3a1 1 0 100-2H6z"
                clipRule="evenodd"
              ></path>
            </svg>
            <span className="sr-only">Message icon</span>
          </span>
        </div>
        <div className="flex items-center justify-between flex-1 ml-3 text-sm font-normal">
          <div className="flex-1">
            <div className="text-sm font-semibold text-gray-900 dark:text-white">{name}</div>
            <div className="text-sm font-normal">{action}</div>
          </div>
          <div>
            <span className="text-xs font-medium text-blue-600 dark:text-blue-500">{formattedDate}</span>
          </div>
        </div>
      </div>
    </button>
  );
}
